import Vue from 'vue';
import Router from 'vue-router';

// Containers
import DefaultContainer from '@/components/_containers/DefaultContainer'
// Inside containers
import MyProjects from '@/components/projects/MyProjects'
import ViewProject from '@/components/projects/ViewProject'
import ProjectAlarms from '@/components/projects/ProjectAlarms'
import ProjectTrends from '@/components/projects/ProjectTrends'
import ProjectSchedules from '@/components/projects/ProjectSchedules'
import ProjectCurrentAlarms from '@/components/projects/ProjectCurrentAlarms'
import ProjectEvents from '@/components/projects/ProjectEvents'
import Settings from '@/components/user/settings/UserSettings'
import Manual from '@/components/others/Manual'
// Other pages
import LoginPage from '@/components/login/LoginPage'
import Page404 from '@/components/errors/Page404'
import Page401 from '@/components/errors/Page401'

Vue.use(Router);

export const router = new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/projects',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'projects',
          name: 'MyProjects',
          component: MyProjects
        },
        {
          path: 'project/view/:projectId',
          name: 'ViewProject',
          component: ViewProject
        },
        {
          path: 'project/alarms/:projectId',
          name: 'ProjectAlarms',
          component: ProjectAlarms
        },
        {
          path: 'project/trends/:projectId',
          name: 'ProjectTrends',
          component: ProjectTrends
        },
        {
          path: 'project/schedules/:projectId',
          name: 'ProjectSchedules',
          component: ProjectSchedules
        },
        {
          path: 'project/alarms/current/:projectId',
          name: 'ProjectCurrentAlarms',
          component: ProjectCurrentAlarms
        },
        {
          path: 'project/events/:projectId',
          name: 'ProjectEvents',
          component: ProjectEvents
        },        
        {
          path: 'settings',
          name: 'UserSettings',
          component: Settings
        },
        {
          path: 'manual',
          name: 'Manual',
          component: Manual
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: LoginPage
    },

    // Error pages here
    {
      path: '/error404',
      name: 'Page404',
      component: Page404
    },
    {
      path: '/error401',
      name: 'Page401',
      component: Page401
    },

    // otherwise redirect to 404
    { path: '*', redirect: '/error404' }
  ]
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('viewer-user');

  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/error404', '/error401'];
  const authRequired = !publicPages.includes(to.path);

  if (authRequired && !loggedIn) {
    return next({
      path: '/login',
      query: { returnUrl: to.fullPath }
    });
  }

  next();
})